import { Box, Button, Paper, Tooltip, Typography } from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import BlockIcon from "@mui/icons-material/Block";
import { LeadsManagementData } from "../hooks/useLeadsManagementData";
import { BRAND_COLOR, STATUS_META } from "../constants";

interface LeadsBulkActionBarProps {
  data: LeadsManagementData;
}

export default function LeadsBulkActionBar({ data }: LeadsBulkActionBarProps) {
  const {
    selectedCount,
    clearSelection,
    requestBulkReport,
    canReportLeads,
    requestBulkReject,
    canRejectLeads,
    allSelectedRejectable,
  } = data;

  if (selectedCount === 0) return null;

  return (
    <Paper
      elevation={4}
      sx={{
        position: "fixed",
        bottom: 26,
        left: "calc(50% + 129px)",
        transform: "translateX(-50%)",
        borderRadius: 3,
        p: "12px 14px 12px 22px",
        display: "flex",
        alignItems: "center",
        gap: 2.5,
        zIndex: 30,
      }}
    >
      <Typography sx={{ fontSize: 14.5, fontWeight: 500, color: "#212121" }}>
        {selectedCount} lead{selectedCount > 1 ? "s" : ""} selected
      </Typography>
      <Box
        component="span"
        onClick={clearSelection}
        sx={{ fontSize: 13.5, color: "#757575", cursor: "pointer" }}
      >
        Clear
      </Box>
      <Tooltip
        title={!allSelectedRejectable ? "Leads that are already reported or rejected can't be rejected" : ""}
        disableHoverListener={allSelectedRejectable}
      >
        <span>
          <Button
            variant="outlined"
            startIcon={<BlockIcon />}
            disabled={!canRejectLeads}
            onClick={requestBulkReject}
            data-tracker="980"
            sx={{
              borderColor: STATUS_META.Rejected.color,
              color: STATUS_META.Rejected.color,
              letterSpacing: "0.4px",
              "&:hover": { borderColor: STATUS_META.Rejected.color, bgcolor: STATUS_META.Rejected.bg },
            }}
          >
            Reject
          </Button>
        </span>
      </Tooltip>
      <Button
        variant="contained"
        startIcon={<SendIcon />}
        disabled={!canReportLeads}
        onClick={requestBulkReport}
        data-tracker="930"
        sx={{ bgcolor: BRAND_COLOR, "&:hover": { bgcolor: "#7B1FA2" }, letterSpacing: "0.4px" }}
      >
        Report to brand
      </Button>
    </Paper>
  );
}
